// frontend/src/components/client/FlightPlanCanvas.jsx
import React, { useState } from 'react';
import { Navigation, MapPin, ExternalLink, Cloud, AlertCircle } from 'lucide-react';

const FlightPlanCanvas = ({ departureIcao, onPlanClick }) => {
  const [showMap, setShowMap] = useState(false);

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
      {/* Header */}
      <div className="p-4 border-b border-gray-700 bg-gray-800/80">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Navigation className="w-5 h-5 text-blue-400" />
            <h3 className="text-white font-semibold">Flight Plan</h3>
          </div>
          <button
            onClick={onPlanClick}
            className="text-sm text-blue-400 hover:text-blue-300 flex items-center gap-1"
          >
            Go to Fuel
            <ExternalLink className="w-3 h-3" />
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-1">Plan your next flight</p>
      </div>

      {/* Content */}
      <div className="p-4">
        {/* Departure info */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex-1">
            <p className="text-xs text-gray-500">Departure</p>
            <div className="flex items-center gap-2 mt-1">
              <MapPin className="w-4 h-4 text-green-400" />
              <span className="text-white font-mono font-bold">{departureIcao || '—'}</span>
            </div>
          </div>
          <div className="text-gray-500 text-xs">→</div>
          <div className="flex-1 text-right">
            <p className="text-xs text-gray-500">Destination</p>
            <div className="flex items-center gap-2 mt-1 justify-end">
              <span className="text-gray-400 text-xs">Select in Fuel</span>
              <MapPin className="w-4 h-4 text-orange-400" />
            </div>
          </div>
        </div>

        {/* Quick actions */}
        <div className="flex flex-wrap gap-2 mt-3">
          <button
            onClick={onPlanClick}
            className="flex-1 py-2 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg text-blue-400 text-sm flex items-center justify-center gap-2 transition"
          >
            <Navigation className="w-4 h-4" />
            Plan Route
          </button>
          <button
            onClick={() => window.open(`https://www.aviationweather.gov/`, '_blank')}
            className="flex-1 py-2 bg-cyan-500/20 hover:bg-cyan-500/30 rounded-lg text-cyan-400 text-sm flex items-center justify-center gap-2 transition"
          >
            <Cloud className="w-4 h-4" />
            Weather
          </button>
        </div>

        {/* Map toggle */}
        <button
          onClick={() => setShowMap(!showMap)}
          className="w-full mt-3 text-xs text-gray-500 hover:text-gray-400 transition flex items-center justify-center gap-1"
        >
          <AlertCircle className="w-3 h-3" />
          {showMap ? 'Hide' : 'Show'} SkyVector Map
        </button>

        {/* SkyVector iframe (optionnel) */}
        {showMap && departureIcao && (
          <div className="mt-3">
            <iframe
              src={`https://skyvector.com/?ll=39.8283,-98.5795&chart=301&zoom=3`}
              className="w-full h-64 rounded-lg border border-gray-700"
              title="SkyVector Map"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
            <p className="text-xs text-gray-500 mt-2 text-center">
              📍 For full features, open SkyVector in a new tab
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlightPlanCanvas;